export const dataHeadsForAutomationLogs = [
    {
      fieldName: "Rule Set",
      id: "rule_name",
      isDefaultHead: true,
      isAbbrivation: false,
    },
    {
      fieldName: "Rule Task",
      id: "rule_task_name",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Configuration",
      id: "rule_config",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Frequency",
      id: "parent_rule_config",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Data Look back window",
      id: "lookback_window",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Total Campaigns",
      id: "campaign_name",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Campaign Name",
      id: "campaign_single_name",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Targetings",
      id: "entity_name",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Ad Set Name",
      id: "parent_entity_name",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Activity Time ",
      id: "created_at",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Change",
      id: "message",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Old Bid",
      id: "decision_old",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "New Bid",
      id: "decision_new",
      isDefaultHead: false,
      isAbbrivation: false,
    },
    {
      fieldName: "Bid Status",
      id: "decision_status",
      isDefaultHead: false,
      isAbbrivation: false,
    },
  ];